let pendingFrame: number | null = null;

const getScrollBehavior = (behavior: ScrollBehavior): ScrollBehavior =>
  window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ? "auto"
    : behavior;

const getMenuOffset = () => {
  const menu = document.querySelector<HTMLElement>("[data-site-menu]");
  return (menu?.getBoundingClientRect().height || 0) + 12;
};

const getSectionTop = (element: HTMLElement) =>
  Math.max(
    0,
    window.scrollY + element.getBoundingClientRect().top - getMenuOffset()
  );

export const cancelPendingScroll = (stopNativeScroll = true) => {
  if (pendingFrame !== null) {
    window.cancelAnimationFrame(pendingFrame);
    pendingFrame = null;
  }

  if (stopNativeScroll) {
    // An instant scroll to the current position stops a running native smooth scroll.
    window.scrollTo({
      top: window.scrollY,
      left: window.scrollX,
      behavior: "auto",
    });
  }
};

export const scrollTo = (
  section: string,
  behavior: ScrollBehavior = "smooth"
) => {
  const element = Array.from(
    document.querySelectorAll<HTMLElement>(`[id="${section}"]`)
  ).find((candidate) => candidate.getClientRects().length > 0);

  if (!element) {
    return false;
  }

  cancelPendingScroll(behavior === "smooth");
  const targetTop = getSectionTop(element);

  window.scrollTo({
    top: targetTop,
    left: 0,
    behavior: getScrollBehavior(behavior),
  });

  return true;
};

export const scrollToTop = (behavior: ScrollBehavior = "smooth") => {
  cancelPendingScroll();

  pendingFrame = window.requestAnimationFrame(() => {
    pendingFrame = null;
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: getScrollBehavior(behavior),
    });
  });
};

export const scrollToApplication = () => {
  scrollTo("application");
};
